export default "__VITE_ASSET__DFH2pal___"